import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useBackClose } from '../../utils/backStack';

// 바깥을 누르거나 Esc·뒤로가기로 닫히는 작은 팝오버
// button({ open, toggle }) 로 여는 버튼을, children 에는 내용(또는 ({ close }) => 내용)을 넘긴다
export function Popover({ button, children, align = 'right', className = '' }) {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);
    const close = useCallback(() => setOpen(false), []);
    useBackClose(open, close);
    useEffect(() => {
        if (!open) return undefined;
        const onDown = (e) => { if (!ref.current?.contains(e.target)) close(); };
        const onKey = (e) => { if (e.key === 'Escape') close(); };
        document.addEventListener('mousedown', onDown);
        document.addEventListener('touchstart', onDown, { passive: true });
        window.addEventListener('keydown', onKey);
        return () => {
            document.removeEventListener('mousedown', onDown);
            document.removeEventListener('touchstart', onDown);
            window.removeEventListener('keydown', onKey);
        };
    }, [open, close]);
    return (
        <div className="nav-popover-wrap" ref={ref}>
            {button({ open, toggle: () => setOpen(v => !v) })}
            {open && <div className={`nav-popover ${align} ${className}`}>{typeof children === 'function' ? children({ close }) : children}</div>}
        </div>
    );
}

export const Switch = ({ checked, onChange, label, disabled }) => (
    <label className={`nav-switch${disabled ? ' disabled' : ''}`}>
        <span>{label}</span>
        <input type="checkbox" checked={checked} disabled={disabled} onChange={e => onChange(e.target.checked)} />
        <span className="nav-switch-track" aria-hidden="true" />
    </label>
);
